<template>
  <!-- 
*
*   detaildeta: {
        edit: "permission.bank_edit",
        add: "permission.bank_add",
        audit: "permission.bank_audit",
        title: "data.bankName",
         biangeng:'that.data.auditState>=2'
         topclass:true,false/// 标题前面的绿标
      },
*
*
*
*
 -->

  <div class="bank_nameblock">
    <div class="changeblock">
      
      <div v-if="detail.topclass == undefinde ? true : detail.topclass">
        <div
          class="historyclass reds"
          v-if="data.auditState > '2' && data.modifiedTime"
        >
          资料变更，变更日期：{{ data.modifiedTime.slice(0, 11) }}
        </div>
        <div class="historyclass orange" v-if="data.auditState == '1'">
          审核中
        </div>
        <div class="historyclass" v-if="data.auditState == '2'">
          {{ data.auditTime ? data.auditTime.substr(0, 10) : "" }} 审核通过
        </div>
      </div>
      <div class="bankname">{{ detail.title }}</div>
    </div>
   
    <!-- data.auditState == 0 ||  || detail.setname!=undefinde?detail.setname.showblock:'' -->
    <div v-if=" data.auditState == 0 ">
<!--  
            <el-button
              type="primary"
              :loading="butshengheloading"
              v-if="detail.add && data.process == '1'"
              @click="updatastate(true)"
            >
        提交审批
      </el-button> -->
     
      <el-button
        type="primary"
        :loading="butshengheloading"
        v-if="isEdit && detail.add && data.process == 1"
        @click="updatastate(false)"
      >
        {{ detail.setname!=undefinde? detail.setname.name : "提交审核" }}
      </el-button>
       <el-button
        type="primary"
        :loading="butshengheloading"
        v-if="isEdit && detail.add && data.process == 4&&isRdcollect"
        @click="updatastate(false)"
      >
        {{ detail.setname!=undefinde? detail.setname.name : "提交审核" }}
      </el-button>
      <!-- <el-button
        type="primary"
        :loading="butshengheloading"
        v-if="!isEdit && detail.add && data.process == 5"
        @click="updatastate(false)"
      >
        {{ detail.setname!=undefinde? detail.setname.name : "提交归档" }}
      </el-button>       -->

      <el-button type="primary" v-if="isEdit && detail.edit" plain @click="edit(data.id)"
        >编辑</el-button
      >
    </div>

    <div v-if="data.auditState == 1 && detail.audit == true">
      <el-button
        type="primary"
        icon="el-icon-check"
        plain
        @click="quanxian(data.id, true)"
        >通过</el-button
      >
      <el-button
        type="warning"
        icon="el-icon-close"
        plain
        @click="quanxian(data.id, false)"
        >退回</el-button
      >
    </div>
    
    <div  v-if="detail.biangeng"> 
      <el-button
        type="warning"
        plain
        @click="changes(data.id)"
        autofocus
        v-if="detail.add == true &&isEdit"
        >资料变更</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      detail: {},
    };
  },
  props: { 
    detaildeta: Object,
    data: Object,
    isEdit:{
      type: 'Boolean',
      default: true
    },
    isRdcollect:{
      type: 'Boolean',
      default: true
    }
  },
  created() {},
  mounted() {
    this.pagedata();
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.pagedata();
      },
    },
    // "wfStatus"
  },
  computed: {
    ...mapGetters(["permission"]),
    //   权限
  },
  methods: {
    pagedata() {
      let that = this;
      let newdatas = new Object();
      for (const [key, value] of Object.entries(that.detaildeta)) {
        // console.log(`${key}: ${value}`);

        if (key == "biangeng") {
          newdatas[`${key}`] = eval(value);
        } else if (key == "setname") {
          newdatas[`${key}`] = value; 
        } else if (key == "topclass") {
          newdatas[`${key}`] = value;
        } else {
          let val = "that." + `${value}`;
          newdatas[`${key}`] = eval(val);
        }
      }
      // console.log(newdatas);
      that.detail = newdatas;
    },
    updatastate(type) {
      this.$emit("updatastate", type);
      this.pagedata();
    },
    quanxian(id, type) {
      this.$emit("quanxian", id, type);
    },
    passcheck(data, type) {
      this.$emit("passcheck", data, type);
    },
    changes(id) {
      this.$emit("changes", id);
    },
    edit(id) {
      this.$emit("edit", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.bank_nameblock {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  .bankname {
    font-size: 18px;
    font-weight: bolder;
  }
  .changeblock {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .historyclass {
      background: #19be6b;
      padding: 5px 10px;
      font-size: 10px;
      border-radius: 0 10px 10px 0;
      margin-right: 10px;
      color: #fff;
    }
    .reds {
      background: #f56c6c;
    }
    .orange {
      background: #fec03d;
    }
  }
}
</style>